<template>
  <div class="is-pulled-right paragraph-s paragraph-dark-gray">{{ formattedDate }}</div>
</template>

<script>
export default {
  props: {
    date: String
  },
  computed: {
    formattedDate() {
      return this.$language.getFormattedDate(this.date, 'MMM DD');
    }
  }
};
</script>
